// UserInfoTemplateコンポーネントをインポート
// ユーザー向けの「ユーザー情報」ページ用テンプレートとして使用
import UserInfoTemplate from "../templates/UserInfoTemplate";

/**
 * UserInfoPageコンポーネント
 * ユーザー向けの「ユーザー情報」ページを表示するためのコンポーネント
 * UserInfoTemplateを利用して、ユーザー情報画面を構築
 */
const UserInfoPage = () => {

    // ユーザー情報ページテンプレートをレンダリング
    // 特別なプロパティを渡さず、UserInfoTemplateをそのまま利用
    return (
        <UserInfoTemplate />
    );
}

// UserInfoPageコンポーネントをデフォルトエクスポート
// 他のファイルからこのコンポーネントをインポートして利用可能にする
export default UserInfoPage;
